import { StringDataDefinition } from "../../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { DataDefinition } from "../../../../rule-engine-core/Common/Data/DataDefinition";

import { getTestInputDataDefinition } from "../../DataDefinition";
import { RuleTableConfiguration } from "../../../../rule-engine-core/Rule/Table/Rule/RuleTableConfiguration";
import { GreaterThanExpression } from "../../../../rule-engine-core/Expressions/Expressions/Logic/GreaterThan";
import { IsFalseExpression } from "../../../../rule-engine-core/Expressions/Expressions/Logic/IsFalse";
import { LessThanExpression } from "../../../../rule-engine-core/Expressions/Expressions/Logic/LessThanExpression";
import { DivideExpression } from "../../../../rule-engine-core/Expressions/Expressions/Math/DivideExpression";
import { AddExpression } from "../../../../rule-engine-core/Expressions/Expressions/Math/AddExpression";
import { AndGroup } from "../../../../rule-engine-core/Expressions/Expressions/Logic/AndGroup";
import { IsTrueExpression } from "../../../../rule-engine-core/Expressions/Expressions/Logic/IsTrue";
import { NotExpression } from "../../../../rule-engine-core/Expressions/Expressions/Logic/NotExpression";
import { ExistsExpression } from "../../../../rule-engine-core/Expressions/Expressions/Logic/Exists";
import { GreaterThanEqualToExpression } from "../../../../rule-engine-core/Expressions/Expressions/Logic/GreaterThanEqualTo";

export const getRuleTableEmpty = (): RuleTableConfiguration => {
    const ruleDefinition = new RuleTableConfiguration();
    ruleDefinition.inputData = getTestInputDataDefinition();
    return ruleDefinition;
};

export const getRuleTableExample = (): RuleTableConfiguration => {
    const ruleDefinition = new RuleTableConfiguration();
    ruleDefinition.inputData = getTestInputDataDefinition();
    ruleDefinition.executionResult = new DataDefinition();

    ruleDefinition.setRuleColumn(ruleDefinition.ruleColumns[0], "vacationDaysRemaining");
    ruleDefinition.addRuleColumn();
    ruleDefinition.setRuleColumn(ruleDefinition.ruleColumns[1], "isManager");
    ruleDefinition.addRuleColumn();
    ruleDefinition.setRuleColumn(ruleDefinition.ruleColumns[2], "vacationDaysUsed");
    ruleDefinition.addRuleColumn();
    ruleDefinition.setRuleColumn(ruleDefinition.ruleColumns[3], "fullTime");

    ruleDefinition.setResultColumnType(ruleDefinition.resultColumns[0], new StringDataDefinition("result_2"));

    ruleDefinition.addRow();
    ruleDefinition.addRow();
    ruleDefinition.addRow();
    ruleDefinition.addRow();
    ruleDefinition.addRow();
    ruleDefinition.addRow();

    // first row
    let greaterThan = new GreaterThanExpression();
    greaterThan.value1.variableName = "vacationDaysRemaining";
    greaterThan.value2.value = 0;

    ruleDefinition.rows[0].cells[0].expression!.expression = greaterThan;

    let isFalse = new IsFalseExpression();
    isFalse.value1.variableName = "isManager";
    ruleDefinition.rows[0].cells[1].expression!.expression = isFalse;

    let lessThan = new LessThanExpression();

    let divide = new DivideExpression();
    divide.divideValue.variableName = "vacationDaysUsed";

    let add = new AddExpression();
    add.value1.variableName = "vacationDaysUsed";
    add.value2.variableName = "vacationDaysRemaining";

    divide.divideBy.subExpression = add;

    lessThan.value1.subExpression = divide;
    lessThan.value2.value = 0.6;

    ruleDefinition.rows[0].cells[2].expression!.expression = lessThan;

    let andExp = new AndGroup();

    let isTrue = new IsTrueExpression();
    isTrue.value1.variableName = "fullTime";
    andExp.elements[0].subExpression = isTrue;

    andExp.add();

    let notExp = new NotExpression();
    let exists = new ExistsExpression();

    exists.dataPath = "disciplinaryActionsHistory";
    notExp.value1.subExpression = exists;

    andExp.elements[1].subExpression = notExp;

    ruleDefinition.rows[0].cells[3].expression!.expression = andExp;

    greaterThan = new GreaterThanExpression();
    greaterThan.value1.variableName = "vacationDaysRemaining";
    greaterThan.value2.value = 0;

    // second row
    ruleDefinition.rows[1].cells[0].expression!.expression = greaterThan;

    isFalse = new IsFalseExpression();
    isFalse.value1.variableName = "isManager";
    ruleDefinition.rows[1].cells[1].expression!.expression = isFalse;

    lessThan = new LessThanExpression();

    divide = new DivideExpression();
    divide.divideValue.variableName = "vacationDaysUsed";

    add = new AddExpression();
    add.value1.variableName = "vacationDaysUsed";
    add.value2.variableName = "vacationDaysRemaining";

    divide.divideBy.subExpression = add;

    lessThan.value1.subExpression = divide;
    lessThan.value2.value = 0.6;

    ruleDefinition.rows[1].cells[2].expression!.expression = lessThan;

    andExp = new AndGroup();

    isFalse = new IsFalseExpression();
    isFalse.value1.variableName = "fullTime";
    andExp.elements[0].subExpression = isFalse;

    andExp.add();

    notExp = new NotExpression();
    exists = new ExistsExpression();

    exists.dataPath = "disciplinaryActionsHistory";
    notExp.value1.subExpression = exists;

    andExp.elements[1].subExpression = notExp;

    ruleDefinition.rows[1].cells[3].expression!.expression = andExp;

    // thrid row
    ruleDefinition.rows[2].cells[0].expression!.expression = greaterThan;

    isFalse = new IsFalseExpression();
    isFalse.value1.variableName = "isManager";
    ruleDefinition.rows[2].cells[1].expression!.expression = isFalse;

    lessThan = new LessThanExpression();

    divide = new DivideExpression();
    divide.divideValue.variableName = "vacationDaysUsed";

    add = new AddExpression();
    add.value1.variableName = "vacationDaysUsed";
    add.value2.variableName = "vacationDaysRemaining";

    divide.divideBy.subExpression = add;

    lessThan.value1.subExpression = divide;
    lessThan.value2.value = 0.8;

    ruleDefinition.rows[2].cells[2].expression!.expression = lessThan;

    andExp = new AndGroup();

    isTrue = new IsTrueExpression();
    isTrue.value1.variableName = "fullTime";
    andExp.elements[0].subExpression = isTrue;

    andExp.add();

    notExp = new NotExpression();
    exists = new ExistsExpression();

    exists.dataPath = "disciplinaryActionsHistory";
    notExp.value1.subExpression = exists;

    andExp.elements[1].subExpression = notExp;

    ruleDefinition.rows[2].cells[3].expression!.expression = andExp;

    // fourth

    ruleDefinition.rows[3].cells[0].expression!.expression = greaterThan;

    isFalse = new IsFalseExpression();
    isFalse.value1.variableName = "isManager";
    ruleDefinition.rows[3].cells[1].expression!.expression = isFalse;

    lessThan = new LessThanExpression();

    divide = new DivideExpression();
    divide.divideValue.variableName = "vacationDaysUsed";

    add = new AddExpression();
    add.value1.variableName = "vacationDaysUsed";
    add.value2.variableName = "vacationDaysRemaining";

    divide.divideBy.subExpression = add;

    lessThan.value1.subExpression = divide;
    lessThan.value2.value = 0.8;

    ruleDefinition.rows[3].cells[2].expression!.expression = lessThan;

    andExp = new AndGroup();

    isFalse = new IsFalseExpression();
    isFalse.value1.variableName = "fullTime";
    andExp.elements[0].subExpression = isFalse;

    andExp.add();

    notExp = new NotExpression();
    exists = new ExistsExpression();

    exists.dataPath = "disciplinaryActionsHistory";
    notExp.value1.subExpression = exists;

    andExp.elements[1].subExpression = notExp;

    ruleDefinition.rows[3].cells[3].expression!.expression = andExp;

    // fifth row
    ruleDefinition.rows[4].cells[0].expression!.expression = greaterThan;

    isFalse = new IsFalseExpression();
    isFalse.value1.variableName = "isManager";
    ruleDefinition.rows[4].cells[1].expression!.expression = isFalse;

    divide = new DivideExpression();
    divide.divideValue.variableName = "vacationDaysUsed";

    add = new AddExpression();
    add.value1.variableName = "vacationDaysUsed";
    add.value2.variableName = "vacationDaysRemaining";

    divide.divideBy.subExpression = add;

    let greaterThanEqual = new GreaterThanEqualToExpression();

    greaterThanEqual.value1.subExpression = divide;
    greaterThanEqual.value2.value = 0.8;

    ruleDefinition.rows[4].cells[2].expression!.expression = greaterThanEqual;

    andExp = new AndGroup();

    isTrue = new IsTrueExpression();
    isTrue.value1.variableName = "fullTime";
    andExp.elements[0].subExpression = isTrue;

    andExp.add();

    notExp = new NotExpression();
    exists = new ExistsExpression();

    exists.dataPath = "disciplinaryActionsHistory";
    notExp.value1.subExpression = exists;

    andExp.elements[1].subExpression = notExp;

    ruleDefinition.rows[4].cells[3].expression!.expression = andExp;

    // sixth
    greaterThan = new GreaterThanExpression();
    greaterThan.value1.variableName = "vacationDaysRemaining";
    greaterThan.value2.value = 0;

    ruleDefinition.rows[5].cells[0].expression!.expression = greaterThan;

    isTrue = new IsTrueExpression();
    isTrue.value1.variableName = "isManager";
    ruleDefinition.rows[5].cells[1].expression!.expression = isTrue;

    lessThan = new LessThanExpression();

    divide = new DivideExpression();
    divide.divideValue.variableName = "vacationDaysUsed";

    add = new AddExpression();
    add.value1.variableName = "vacationDaysUsed";
    add.value2.variableName = "vacationDaysRemaining";

    divide.divideBy.subExpression = add;

    lessThan.value1.subExpression = divide;
    lessThan.value2.value = 0.6;

    ruleDefinition.rows[5].cells[2].expression!.expression = lessThan;

    andExp = new AndGroup();

    isTrue = new IsTrueExpression();
    isTrue.value1.variableName = "fullTime";
    andExp.elements[0].subExpression = isTrue;

    andExp.add();

    notExp = new NotExpression();
    exists = new ExistsExpression();

    exists.dataPath = "disciplinaryActionsHistory";
    notExp.value1.subExpression = exists;

    andExp.elements[1].subExpression = notExp;

    ruleDefinition.rows[5].cells[3].expression!.expression = andExp;

    greaterThan = new GreaterThanExpression();
    greaterThan.value1.variableName = "vacationDaysRemaining";
    greaterThan.value2.value = 0;

    // seventh
    greaterThan = new GreaterThanExpression();
    greaterThan.value1.variableName = "vacationDaysRemaining";
    greaterThan.value2.value = 0;

    ruleDefinition.rows[6].cells[0].expression!.expression = greaterThan;

    isTrue = new IsTrueExpression();
    isTrue.value1.variableName = "isManager";
    ruleDefinition.rows[6].cells[1].expression!.expression = isTrue;

    divide = new DivideExpression();
    divide.divideValue.variableName = "vacationDaysUsed";

    add = new AddExpression();
    add.value1.variableName = "vacationDaysUsed";
    add.value2.variableName = "vacationDaysRemaining";

    divide.divideBy.subExpression = add;

    greaterThanEqual = new GreaterThanEqualToExpression();
    greaterThanEqual.value1.subExpression = divide;
    greaterThanEqual.value2.value = 0.6;

    ruleDefinition.rows[6].cells[2].expression!.expression = greaterThanEqual;

    andExp = new AndGroup();

    isFalse = new IsFalseExpression();
    isFalse.value1.variableName = "fullTime";
    andExp.elements[0].subExpression = isFalse;

    andExp.add();

    notExp = new NotExpression();
    exists = new ExistsExpression();

    exists.dataPath = "disciplinaryActionsHistory";
    notExp.value1.subExpression = exists;

    andExp.elements[1].subExpression = notExp;

    ruleDefinition.rows[6].cells[3].expression!.expression = andExp;

    greaterThan = new GreaterThanExpression();
    greaterThan.value1.variableName = "vacationDaysRemaining";
    greaterThan.value2.value = 0;

    ruleDefinition.rows[0].resultCells[0].value = "Auto-Approve";
    ruleDefinition.rows[1].resultCells[0].value = "Approve with ";
    ruleDefinition.rows[2].resultCells[0].value = "Manual Approve";
    ruleDefinition.rows[3].resultCells[0].value = "Reject";
    ruleDefinition.rows[4].resultCells[0].value = "Reject";
    ruleDefinition.rows[5].resultCells[0].value = "Auto-Approve";
    ruleDefinition.rows[6].resultCells[0].value = "Manual-Approve";

    ruleDefinition.getDefaultResultByOrder(0)!.value = "Manual Approve";

    return ruleDefinition;
};
